import type { AttributeValue, Tracer } from '@opentelemetry/api'
import {
  ATTRIBUTE_NAME_REMOTE_SESSION_ID,
  ATTRIBUTE_NAME_SESSION_ID,
  ATTRIBUTE_NAME_SESSION_PROMPT,
  ATTRIBUTE_NAME_TOKEN_USAGE_INPUT_TOKENS,
  ATTRIBUTE_NAME_TOKEN_USAGE_OUTPUT_TOKENS,
  ATTRIBUTE_NAME_TOKEN_USAGE_TOTAL_TOKENS,
  ATTRIBUTE_NAME_TOOL_CALL_COUNT,
  ATTRIBUTE_NAME_TOOL_CALL_ERROR_COUNT,
  SPAN_NAME_FRISK_SESSION,
} from '../../telemetry/constants'
import { FriskSpan } from './frisk-span'

const FIELDS = {
  sessionId: ATTRIBUTE_NAME_SESSION_ID,
  remoteSessionId: ATTRIBUTE_NAME_REMOTE_SESSION_ID,
  prompt: ATTRIBUTE_NAME_SESSION_PROMPT,
  toolCallCount: ATTRIBUTE_NAME_TOOL_CALL_COUNT,
  toolCallErrorCount: ATTRIBUTE_NAME_TOOL_CALL_ERROR_COUNT,
  // Cumulative token usage summed across every LLM call in the session.
  inputTokens: ATTRIBUTE_NAME_TOKEN_USAGE_INPUT_TOKENS,
  outputTokens: ATTRIBUTE_NAME_TOKEN_USAGE_OUTPUT_TOKENS,
  totalTokens: ATTRIBUTE_NAME_TOKEN_USAGE_TOTAL_TOKENS,
} as const

/** Typed span for the Frisk session root. */
export class SessionSpan extends FriskSpan {
  constructor(args: { tracer: Tracer; parent?: FriskSpan | null }) {
    super({
      ...args,
      spanName: SPAN_NAME_FRISK_SESSION,
      attributeFields: FIELDS,
    })
  }

  setAttributes(values: {
    sessionId?: string
    remoteSessionId?: string
    prompt?: string
    toolCallCount?: number
    toolCallErrorCount?: number
    inputTokens?: number
    outputTokens?: number
    totalTokens?: number
  }): void {
    this.setAttributesByField(
      values as Record<string, AttributeValue | undefined>,
    )
  }
}
